export const OUT_OF_HOURS_MARKETS = ["DE", "ES", "FR", "IT", "RU"];
